import styled from 'styled-components';

interface InsightSummaryProps {
  title: string;
  content: string;
  category?: string;
  titleColor?: string;
  contentColor?: string;
  bg?: string;
}

const InsightSummary = ({
  title,
  content,
  category,
  titleColor,
  contentColor,
  bg,
}: InsightSummaryProps) => {
  const hasCategory = Boolean(category?.trim());

  return (
    <Div $bg={bg}>
      <TitleDiv>
        <Title $color={titleColor}>{title}</Title>
        {hasCategory && <Category>{category} 기준</Category>}
      </TitleDiv>
      <Content $color={contentColor}>{content}</Content>
    </Div>
  );
};

export default InsightSummary;

const Div = styled.div<{ $bg?: string }>`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 16px;
  border-radius: 8px;
  background-color: ${({ $bg }) => $bg ?? '#F4F5F7'};
`;

const TitleDiv = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
`;

const Title = styled.div<{ $color?: string }>`
  font-size: 16px;
  font-weight: 700;
  color: ${({ $color }) => $color ?? '#424854'};
`;

const Category = styled.div`
  display: flex;
  height: 24px;
  padding: 0 8px;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  background: #e8e9ed;
  color: #424854;
  font-size: 13px;
  font-weight: 700;
  line-height: 20px;
  letter-spacing: -0.26px;
`;

const Content = styled.div<{ $color?: string }>`
  font-size: 14px;
  font-weight: 500;
  color: ${({ $color }) => $color ?? '#787d87'};
  white-space: pre-line;
  word-break: keep-all;
`;
